/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UsersListAnotherName
 */
export interface UsersListAnotherName {
    /**
     * 
     * @type {Date}
     * @memberof UsersListAnotherName
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof UsersListAnotherName
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof UsersListAnotherName
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof UsersListAnotherName
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof UsersListAnotherName
     */
    usersListId: number;
    /**
     * 
     * @type {string}
     * @memberof UsersListAnotherName
     */
    anotherName: string;
}

export function UsersListAnotherNameFromJSON(json: any): UsersListAnotherName {
    return UsersListAnotherNameFromJSONTyped(json, false);
}

export function UsersListAnotherNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersListAnotherName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'version': json['version'],
        'updatedAt': (new Date(json['updatedAt'])),
        'id': json['id'],
        'usersListId': json['usersListId'],
        'anotherName': json['anotherName'],
    };
}

export function UsersListAnotherNameToJSON(value?: UsersListAnotherName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': (value.createdAt.toISOString()),
        'version': value.version,
        'updatedAt': (value.updatedAt.toISOString()),
        'id': value.id,
        'usersListId': value.usersListId,
        'anotherName': value.anotherName,
    };
}


